import Icon from "@/components/common/icon";

export default function Tg() {
  return (
    <a
      href="https://telegram.me/farkop_rubot"
      target="_blank"
      rel="noreferrer"
      id="tgLink"
    >
      <Icon id="tg" />
    </a>
  );
}
